import styled, { css } from 'styled-components';

import Image from '../../Image/Image';
import TextLink from '../../TextLink/TextLink';
import variables from '../../../../styles/variables';

interface IndexProps {
  readonly $index?: number;
}

export const Wrapper = styled.section<IndexProps>`
  display: flex;
  flex-direction: unset;
  align-items: center;
  max-width: 100%;
  width: 100%;
  position: relative;
  margin: 40px auto;

  ${({ $index }) => ($index === 0
    && css`
      margin: 0 auto 40px;
  `)}
`;

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 ${variables.layoutPadding}rem;
  max-width: ${variables.defaultWidth}px;

  @media screen and (max-width: 1024px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const Banner = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  border-radius: 16px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.10);
`;

export const BannerCta = styled(TextLink)`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-decoration:none;
  padding: 0;
  border: none;
  border-radius: 16px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.10);
  background-color: transparent !important;
  background: none !important;

  &:hover,
  &:focus {
    z-index: 2;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.15) !important;
  }
`;

export const DesktopBannerImage = styled(Image)`
  display: block !important;
  grid-area: 1/1;
  width: 100%;
  height: auto;
  border-radius: 20px;
  @media screen and (max-width: 1023px) {
    display: none !important;
  }
`;

export const TabletBannerImage = styled(Image)`
  display: none !important;
  grid-area: 1/1;
  width: 100%;
  height: auto;
  border-radius: 20px;
  @media screen and (max-width: 1023px) {
    display: block !important;
  }
  @media screen and (max-width: 767px) {
    display: none !important;
  }
`;

export const MobileBannerImage = styled(Image)`
  display: none !important;
  grid-area: 1/1;
  width: 100%;
  height: auto;
  border-radius: 20px;
  @media screen and (max-width: 767px) {
    display: block !important;
  }
`;
